import { render } from "./Home.vue?vue&type=template&id=6011fe71"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\Workout-Tracker\\workout-tracker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])